import { render, staticRenderFns } from "./social-club-feeds.vue?vue&type=template&id=1df1c53e&scoped=true&lang=pug"
import script from "./social-club-feeds.js?vue&type=script&lang=js&external"
export * from "./social-club-feeds.js?vue&type=script&lang=js&external"
import style0 from "./social-club-feeds.vue?vue&type=style&index=0&id=1df1c53e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df1c53e",
  null
  
)

export default component.exports